import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, SubCategoryStatus } from './index';
import { PaginationProps } from '../types';

export type SubCategoryListData = AnyObject

export type SubCategoryListResponse = SubCategoryListData

export type SubCategoryOrderColumn = 'id' | 'text' | 'likeNumber' | 'dislikeNumber' | 'subSubCategoryCount' | 'createdAt' | 'updatedAt';
export type SubCategoryEntity = 'business' | 'article' | 'international_community' | 'category' | 'subcategory';
export const SubCategoryEntityTitle: Record<SubCategoryEntity, string> = {
  business: 'Business',
  article: 'Article',
  international_community: 'International community',
  category: 'Category',
  subcategory: 'Subcategory'
}

export type SubCategoryListParams = PaginationProps<SubCategoryOrderColumn> & {
  text?: string;
  category?: string;
  subCategory?: string;
  article?: string;
  business?: string;
  user?: string
  entity?: SubCategoryEntity | null;
  status?: SubCategoryStatus | null;
}

export const subCategoryList = (payload: SubCategoryListParams): Action<SubCategoryListParams> => ({
  type: actions.subCategoryListTrigger.toString(),
  payload,
});

export const subCategoryListClear = (): Action => ({
  type: actions.subCategoryListClear.toString(),
});

export const subCategoryListErrorClear = (): Action => ({
  type: actions.subCategoryListErrorReset.toString(),
});

export function* subCategoryListRequestSaga({ payload }: Action<SubCategoryListParams>) {
  yield put({
    type: actions.subCategoryListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.subCategoryListError.toString(),
      payload: {
        message: 'SubCategoryList: Parameters not passed.',
      },
    });

    return;
  }

  const { roles, ...restParams } = payload as Record<string, string>;

  const params = new URLSearchParams(Object.entries(restParams).filter((entry) => !!(entry[1] as string)));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}sub-categories?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<SubCategoryListData, SubCategoryListResponse>(
    response,
    actions.subCategoryListSuccess.toString(),
    actions.subCategoryListError.toString(),
    false,
    (subCategoryListData) => subCategoryListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.subCategoryListTrigger.toString(),
    defaultProcessingSaga(
      subCategoryListRequestSaga,
      {
        error: actions.subCategoryListError.toString(),
        locationCancel: actions.subCategoryListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.subCategoryListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.subCategoryListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.subCategoryListErrorReset.toString(),
    });
  });
}
